<ng-container *ngIf="page">
    <ng-container *ngIf="page_types.QRS === page">
        <app-qrs-wrapper></app-qrs-wrapper>
    </ng-container>
    <ng-container *ngIf="page_types.POPUPS === page">
        <app-popups-wrapper></app-popups-wrapper>
    </ng-container>
</ng-container>